import axios from 'axios';
import { apiUrl } from './index';

export default {
  getClickouts(params = {}) {
    return axios({
      method: 'get',
      url: `${apiUrl}/reports/performance/clickouts`,
      params,
    });
  },
  getEngagements(params = {}) {
    return axios({
      method: 'get',
      url: `${apiUrl}/reports/performance/engagements`,
      params,
    });
  },
  getDeals(params) {
    return axios({
      method: 'get',
      url: `${apiUrl}/reports/performance/engagements/deal`,
      params,
    });
  },
  getChartSummary(params = {}) {
    return axios({
      method: 'get',
      url: `${apiUrl}/reports/performance/summary`,
      params,
    });
  },
  getTopDeals(params = {}) {
    return axios({
      method: 'get',
      url: `${apiUrl}/reports/performance/top_deals`,
      params,
    });
  },
  getStatuses() {
    return axios({
      method: 'get',
      url: `${apiUrl}/reports/performance/statuses`,
    });
  },
  getSubmissionTypes() {
    return axios({
      method: 'get',
      url: `${apiUrl}/reports/performance/submission_types`,
    });
  },

  getDaily(options = {}) {
    const { contract, ...params } = options;

    if (contract > -1) {
      params.contract_id = contract;
    }

    return axios({
      method: 'get',
      url: `${apiUrl}/reports/daily`,
      params,
    });
  },
  getDailyCpm(options = {}) {
    const { advertiser, businessId, merchantId, ...params } = options;

    if (advertiser > -1) {
      params.advertiser_id = advertiser;
    }

    if (businessId > -1) {
      params.business_id = businessId;
    }

    if (merchantId > -1) {
      params.merchant_id = merchantId;
    }

    return axios({
      method: 'get',
      url: `${apiUrl}/reports/cpm`,
      params,
    });
  },
  getDailyAdvanced(options = {}) {
    const { contract, ...params } = options;

    if (contract > -1) {
      params.contract_id = contract;
    }

    return axios({
      method: 'get',
      url: `${apiUrl}/reports/daily/advanced`,
      params,
    });
  },
  getMonthly(options) {
    const { billing_account_id, country, month, year } = options;
    const params = {
      billing_account_id,
      country,
      month,
      year,
    };

    return axios({
      method: 'get',
      url: `${apiUrl}/reports/monthly`,
      params,
    });
  },
  getAccounts() {
    return axios({
      method: 'get',
      url: `${apiUrl}/reports/billing`,
    });
  },
  getContracts() {
    return axios({
      method: 'get',
      url: `${apiUrl}/reports/contracts`,
    });
  },
  getAdvancedContracts() {
    return axios({
      method: 'get',
      url: `${apiUrl}/reports/contracts?advanced=1`,
    });
  },
  downloadPerformanceReport(params) {
    return axios({
      method: 'get',
      responseType: 'blob',
      url: `${apiUrl}/reports/performance/download`,
      params,
    });
  },
  downloadDaily(options = {}) {
    const { contract, ...params } = options;

    if (contract > -1) {
      params.contract_id = contract;
    }

    return axios({
      method: 'get',
      responseType: 'blob',
      url: `${apiUrl}/reports/daily/download`,
      params,
    });
  },
  downloadDailyAdvanced(options = {}) {
    const { contract, ...params } = options;

    if (contract > -1) {
      params.contract_id = contract;
    }

    return axios({
      method: 'get',
      responseType: 'blob',
      url: `${apiUrl}/reports/daily/advanced/download`,
      params,
    });
  },
  downloadDailyCpm(options = {}) {
    const { advertiser, businessId, merchantId, ...params } = options;

    if (advertiser > -1) {
      params.advertiser_id = advertiser;
    }

    if (businessId) {
      params.business_id = businessId;
    }

    if (merchantId > -1) {
      params.merchant_id = merchantId;
    }

    return axios({
      method: 'get',
      responseType: 'blob',
      url: `${apiUrl}/reports/cpm/download`,
      params,
    });
  },
  verifyLink({ hash }) {
    return axios({
      method: 'post',
      url: `${apiUrl}/mail_analytics/${hash}`,
    });
  },
};
